  import { useState } from "react";
  import { useNavigate } from "react-router-dom";
  import { BodyText, Flex, TextArea } from "@utilitywarehouse/hearth-react";

  import { ConfirmationAnswer } from "../../../context/vulnerability/VulnerabilityContext";
  import WhyWeWant from "../../WhyWeWant";
  import { QuestionsDataTest } from "../constants";
  import NavigationButtons from "../NavigationButtons";
  import MultiChoiceSelect from "../../MultiChoiceSelect";
  
export interface ConfirmationWithDetailQuestionProps {
  step: string;
  title: string;
  subTitle?: string;
  whyWeWantTexts?: string[];
  value?: ConfirmationAnswer;
  detail?: string;
  requireAnswer?: boolean;
  placeholder?: string;
  onContinue: () => void;
  onChange: (answer?: ConfirmationAnswer, detail?: string) => void;
  onBack?: () => void;
}
  
const ConfirmationWithDetailQuestion: React.FC<ConfirmationWithDetailQuestionProps> = ({
  step,
  title,
  subTitle,
  onContinue,
  whyWeWantTexts,
  value,
  detail,
  onChange,
  onBack,
  placeholder,
  requireAnswer,
}) => {  
  const navigate = useNavigate();

  const [hasSelectError, setHasSelectError] = useState(false);
  const [hasDetailsError, setHasDetailsrror] = useState(false);

  const onContinueClick = () => {
    if (!value) {
      setHasSelectError(true);
    } else if (value ===ConfirmationAnswer.Yes && !detail) {
      setHasDetailsrror(true)
    } else {
      setHasSelectError(false);
      setHasDetailsrror(false)
      onContinue();
    }
  };

  const handleSelectChange = (v: ConfirmationAnswer) => {
    onChange(v, detail)
  }
  
  const handleDetailChange = (v: string) => {
    onChange(value, v)
  }

  return (
    <Flex direction="column" gap="500">
      {step ? (
        <BodyText weight="semibold">
        {step}
        </BodyText>
      ) : null}

      <Flex direction="column" gap="150">
        <BodyText weight="semibold" data-testid={QuestionsDataTest.TITLE}>
          {title}

          {subTitle ? (
            <BodyText color="secondary" data-testid={QuestionsDataTest.SUB_TITLE}>
              {subTitle}
            </BodyText>
          ) : null}
        </BodyText>

        <MultiChoiceSelect
          value={value}
          requireAnswer={requireAnswer}
          onChange={handleSelectChange}
          hasError={hasSelectError}
        />
      </Flex>
          
      {value !== ConfirmationAnswer.Yes && whyWeWantTexts ? (
        <WhyWeWant whyWeWantTexts={whyWeWantTexts} />
      ) : null}

      {value === ConfirmationAnswer.Yes ? (
        <TextArea
          required
          label=""
          placeholder={placeholder}
          rows={4}
          onChange={(e) => handleDetailChange(e.target.value)}
          validationStatus={hasDetailsError ? "invalid" : undefined}
          validationText="Please fill in the above to continue"
          data-testid={hasDetailsError ? QuestionsDataTest.ERROR : QuestionsDataTest.CONFIRM_DETAILS_INPUT}
          style={{ maxWidth: "100%" }}
        />
      ) : null}
      
      <NavigationButtons
        onBack={() => (onBack ? onBack() : navigate(-1))}
        onContinue={onContinueClick}
      />
    </Flex>
  );
};

export default ConfirmationWithDetailQuestion;